import { ButtonDetailCommissionComponent } from '@components/button/tables/commissions/button-modify-commission.component';
import { ButtonDeleteCommissionComponent } from '@components/button/tables/commissions/button-delete-commission.component';

export class CommissionsSettings {
  public static gridSettings() {
    return {
      actions: false,
      noDataMessage: 'Nessun dato trovato',
      attr: {
        class: 'table table-bordered',
      },
      pager: {
        display: true,
        perPage: 25,
      },
      columns: {
        detailButton: {
          type: 'custom',
          renderComponent: ButtonDetailCommissionComponent,
          editable: false,
          addable: false,
          filter: false,
          width: '50px',
        },
        deleteButton: {
          type: 'custom',
          renderComponent: ButtonDeleteCommissionComponent,
          editable: false,
          addable: false,
          filter: false,
          width: '50px',
        },
        id: {
          title: 'Id',
          width: '70px',
        },
        anno: {
          title: 'Anno',
        },
        tipoVenditore: {
          title: 'Tipo venditore',
          filter: {
            type: 'list',
            config: {
              list: [
                { value: 'DIPENDENTE', title: 'DIPENDENTE' },
                { value: 'ENASARCO', title: 'ENASARCO' },
              ],
            },
          },
        },
        percentualeProvvigione: {
          title: '% Provvigione',
        },
        enabled: {
          title: 'Abilitato',
          valuePrepareFunction: (abilitato) => {
            if (abilitato) {
              return 'Si';
            } else {
              return 'No';
            }
          },
          filter: {
            type: 'list',
            config: {
              list: [
                { value: true, title: 'Si' },
                { value: false, title: 'No' },
              ],
            },
          },
        },
      },
      delete: null,
    };
  }
}
